import React, {
  forwardRef,
  Fragment,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import { BoSungVanDesEndpoint } from "../../../../../../service/Meet";
import {
  Enums_Mau,
  _Enums_Loai,
  _Enum_Loai_Value,
  _Enum_Trang_Thai_Van_De,
} from "../../../../../action/defaultEnums";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import TeamPending from "./Pending";
import {
  CHECK_CONFIRM,
  CHECK_WARNING,
} from "../../../../../../components/alert/Alert";
import { TOKEN_CLIENT_INFO } from "../../../../../../actions/constants";
import { useDispatch, useSelector } from "react-redux";
import { TypeEnums } from "../../reloadConstants";
import { actionGRPC } from "../../../Redux/ActionsMeeting";
import { PopoverBody, UncontrolledPopover } from "reactstrap";
import FormAttachFile from "../../FormAttachFile";
import DeniedBoSungVanDesEndpoint from "../../../../../../service/Meet/DeniedBoSungVanDesEndpoint";
import "./style.scss";
import { Icon } from "@mui/material";

// Chart colors
const CHART_COLORS = {
  approve: "#10b981",
  reject: "#ef4444",
  other: "#f59e0b",
  noResponse: "#9ca3af",
};

// Status configuration
const STATUS_CONFIG = {
  [_Enum_Trang_Thai_Van_De.HoanThanh]: {
    color: "#10b981",
    bgColor: "#d1fae5",
    label: "Hoàn thành",
    icon: "check-circle",
  },
  [_Enum_Trang_Thai_Van_De.HoatDong]: {
    color: "#3b82f6",
    bgColor: "#dbeafe",
    label: "Đang thảo luận",
    icon: "comments",
  },
  [_Enum_Trang_Thai_Van_De.Moi]: {
    color: "#f59e0b",
    bgColor: "#fef3c7",
    label: "Chờ xử lý",
    icon: "clock",
  },
};

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  if (percent === 0) return null;

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor="middle"
      dominantBaseline="central"
      style={{ fontWeight: 600, fontSize: 14 }}
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

function generateRandomColor(numberColor) {
  var letters = "0123456789ABCDEF";
  const colors = Array.from(Array(numberColor).keys()).map(() => {
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  });
  return colors;
}

// Result Card Component
const ResultCard = ({
  option,
  total,
  isOther,
  canShowVoters,
  loai,
  index,
  prefix = "result",
}) => {
  const soTL =
    loai === _Enum_Loai_Value.CongKhai
      ? option.soCauTL?.length || 0
      : option.daChon || 0;
  const percentage = total > 0 ? ((soTL / total) * 100).toFixed(1) : 0;

  const getVariant = () => {
    const content = option.noiDung?.toLowerCase() || "";
    if (content.includes("đồng ý") && !content.includes("không"))
      return "approve";
    if (content.includes("không đồng ý") || content.includes("từ chối"))
      return "reject";
    if (isOther) return "other";
    return "default";
  };

  const variant = getVariant();
  const colors = {
    approve: { bg: "#d1fae5", color: "#059669", icon: "check_circle" },
    reject: { bg: "#fee2e2", color: "#dc2626", icon: "cancel" },
    other: { bg: "#fef3c7", color: "#d97706", icon: "add_comment" },
    default: { bg: "#f3f4f6", color: "#4b5563", icon: "receipt_long" },
  };

  const style = colors[variant];
  const cardId = `${prefix}${index}`;

  return (
    <Fragment>
      <div
        className="result-option-card"
        id={cardId}
        style={{ "--result-bg": style.bg, "--result-color": style.color }}
      >
        <div className="result-icon">
          <Icon>{style.icon}</Icon>
        </div>
        <div className="result-content">
          <span className="result-label">{option.noiDung}</span>
          <div className="result-bar-container">
            <div className="result-bar" style={{ width: `${percentage}%` }} />
          </div>
        </div>
        <div className="result-stats">
          <span className="result-count">
            {soTL}/{total}
          </span>
          <span className="result-percent">{percentage}%</span>
        </div>
      </div>
      {canShowVoters &&
        loai !== _Enum_Loai_Value.Kin &&
        option.soCauTL?.length > 0 && (
          <UncontrolledPopover placement="top" target={cardId} trigger="hover">
            <PopoverBody className="voter-popover-body">
              <div className="voter-popover-title">Danh sách bình chọn</div>
              {option.soCauTL.map((cb, idx) => (
                <div className="voter-item" key={idx}>
                  <Icon>person</Icon>
                  <span>{cb}</span>
                </div>
              ))}
            </PopoverBody>
          </UncontrolledPopover>
        )}
    </Fragment>
  );
};

// Legend Item Component
const LegendItem = ({ item, total }) => {
  const percentage = total > 0 ? ((item.value / total) * 100).toFixed(1) : 0;

  return (
    <div className="legend-item">
      <div className="legend-color" style={{ backgroundColor: item.fill }} />
      <div className="legend-content">
        <span className="legend-label">{item.name}</span>
        <span className="legend-value">
          {item.value} phiếu ({percentage}%)
        </span>
      </div>
    </div>
  );
};

const ModalKetQua = forwardRef((props, ref) => {
  const { _dataKQBQ, isOpen, isClose, isDienBien, loading } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [data, setData] = useState(null);
  const [dataBieuDo, setDataBieuDo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [thamGiaBQ, setThamGiaQB] = useState([]);
  const { noiDung, thamDus, grpc, phienHop } = useSelector(
    (state) => state.meetingRProcess,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (data?.id && thamDus) {
      DeniedBoSungVanDesEndpoint.getListDeny(data.id)
        .then(({ resultObj }) => {
          const canBos = thamDus.thamGia.filter(
            (cur) => resultObj.includes(cur.id) === false,
          );
          setThamGiaQB(canBos);
        })
        .catch(() => {
          CHECK_WARNING("Lấy dữ liệu không thành công");
        });
    }
  }, [thamDus, data]);

  const getThongTinBQ = useCallback(
    (bieuQuyet, status) => {
      status && setIsLoading(status);
      BoSungVanDesEndpoint.getKetQuaBieuQuyet(bieuQuyet.id).then(
        ({ resultObj: { ketQuas } }) => {
          bieuQuyet.phuongAnBoSungs.forEach((pa, i, arr) => {
            const indexKQ = ketQuas
              ? ketQuas.findIndex((kq) => Object.keys(kq).includes(pa.id))
              : -1;
            arr[i].soCauTL = indexKQ > -1 ? ketQuas[indexKQ][pa.id] : [];
          });
          setData((pre) => ({
            ...pre,
            ..._dataKQBQ,
            phuongAnBoSungs: bieuQuyet.phuongAnBoSungs,
          }));
        },
      );
    },
    [_dataKQBQ],
  );

  const getDataBieuQuyet = useCallback(
    (idVanDe, isLoading) => {
      BoSungVanDesEndpoint.getVanDesById(idVanDe)
        .then((res) => {
          getThongTinBQ(res, isLoading);
          isLoading && setIsLoading(false);
        })
        .catch((err) => {
          CHECK_WARNING(err);
        });
    },
    [getThongTinBQ],
  );

  useEffect(() => {
    if (_dataKQBQ) {
      getDataBieuQuyet(_dataKQBQ.id, loading);
    } else {
      setData(null);
      setIsLoading(false);
    }
  }, [_dataKQBQ, loading, getDataBieuQuyet]);

  const reloadData = useCallback(
    (_grpc) => {
      if (!isOpen) return;
      const { data } = _grpc;
      if (data.type === TypeEnums.KETQUA) {
        getDataBieuQuyet(data.key);
        dispatch(actionGRPC({ ..._grpc, isViewed: true }));
      } else if (data.type === TypeEnums.VANDEHOANTHANH) {
        isClose();
        dispatch(actionGRPC({ ..._grpc, isViewed: true }));
      }
    },
    [dispatch, getDataBieuQuyet, isClose, isOpen],
  );

  useEffect(() => {
    if (grpc && !grpc.isViewed) {
      reloadData(grpc);
    }
  }, [grpc, reloadData]);

  useImperativeHandle(
    ref,
    () => ({
      setKetQuaBQ: (item) => {
        getThongTinBQ(item);
      },
    }),
    [getThongTinBQ],
  );

  const hoanThanh = useCallback(() => {
    let totalAns = 0;
    data.phuongAnBoSungs.forEach((f) => (totalAns += f.soCauTL.length));
    const mes =
      thamGiaBQ.length - totalAns !== 0
        ? `Có ${thamGiaBQ.length - totalAns} thành viên chưa phản hồi ý kiến`
        : "";
    CHECK_CONFIRM(mes, "Bạn có muốn hoàn thành vấn đề ?").then((res) => {
      if (res && res.isConfirmed) {
        BoSungVanDesEndpoint.editVanDes(_dataKQBQ.id, {
          trangThai: _Enum_Trang_Thai_Van_De.HoanThanh,
        });
      }
    });
  }, [data, thamGiaBQ, _dataKQBQ]);

  useEffect(() => {
    if (data) {
      let totalAns = 0;
      data.phuongAnBoSungs.forEach((f) => {
        if (data.loai === _Enum_Loai_Value.CongKhai) {
          totalAns += f.soCauTL.length;
        } else {
          totalAns += f.daChon;
        }
      });

      if (data.mau === "BQ") {
        let dataBieuDoBQ = [];

        switch (data.loai) {
          case _Enum_Loai_Value.CongKhai:
            dataBieuDoBQ.push(
              {
                name: "Đồng ý",
                value:
                  data.phuongAnBoSungs.find((f) => f.noiDung === "Đồng ý")
                    ?.soCauTL.length || 0,
                fill: CHART_COLORS.approve,
              },
              {
                name: "Không đồng ý",
                value:
                  data.phuongAnBoSungs.find((f) => f.noiDung === "Không đồng ý")
                    ?.soCauTL.length || 0,
                fill: CHART_COLORS.reject,
              },
              {
                name: "Ý kiến khác",
                value: data.phuongAnBoSungs
                  .filter((f) => f.yKienKhac)
                  .reduce((sum, kq) => sum + kq?.soCauTL.length, 0),
                fill: CHART_COLORS.other,
              },
              {
                name: "Không phản hồi",
                value: thamGiaBQ.length - totalAns,
                fill: CHART_COLORS.noResponse,
              },
            );
            break;
          default:
            dataBieuDoBQ.push(
              {
                name: "Đồng ý",
                value:
                  data.phuongAnBoSungs.find((f) => f.noiDung === "Đồng ý")
                    ?.daChon || 0,
                fill: CHART_COLORS.approve,
              },
              {
                name: "Không đồng ý",
                value:
                  data.phuongAnBoSungs.find((f) => f.noiDung === "Không đồng ý")
                    ?.daChon || 0,
                fill: CHART_COLORS.reject,
              },
              {
                name: "Ý kiến khác",
                value: data.phuongAnBoSungs
                  .filter((f) => f.yKienKhac)
                  .reduce((sum, kq) => sum + kq?.daChon, 0),
                fill: CHART_COLORS.other,
              },
              {
                name: "Không phản hồi",
                value: thamGiaBQ.length - totalAns,
                fill: CHART_COLORS.noResponse,
              },
            );
            break;
        }
        setDataBieuDo([...dataBieuDoBQ]);
      } else {
        const yKienKhacs = data.phuongAnBoSungs.filter((f) => f.yKienKhac);
        let cauTL = 0;
        yKienKhacs.forEach((yKienKhac) => {
          switch (data.loai) {
            case _Enum_Loai_Value.CongKhai:
              cauTL += yKienKhac?.soCauTL.length;
              break;
            default:
              cauTL += yKienKhac?.daChon;
              break;
          }
        });

        const colors = generateRandomColor(data.phuongAnBoSungs.length + 2);
        let colorForOtherAndNot = colors.slice(-2);
        data.phuongAnBoSungs.forEach((pa, i, arr) => {
          arr[i]["fill"] = colors[i];
        });
        const dataBieuDoPA = data.phuongAnBoSungs
          .filter((f) => !f.yKienKhac)
          .map((item) => ({
            name: item.noiDung,
            value:
              data.loai === _Enum_Loai_Value.CongKhai
                ? item.soCauTL.length
                : item.daChon,
            fill: item.fill,
          }))
          .concat(
            {
              name: "Ý kiến khác",
              value: cauTL || 0,
              fill: colorForOtherAndNot[0],
            },
            {
              name: "Không phản hồi",
              value: thamGiaBQ.length - totalAns,
              fill: colorForOtherAndNot[1],
            },
          );
        setDataBieuDo([...dataBieuDoPA]);
      }
    }
  }, [data, thamGiaBQ]);

  // Calculate totals for stats
  const stats = useMemo(() => {
    if (!data) return { totalVotes: 0, totalParticipants: 0, noResponse: 0 };

    let totalVotes =
      data.phuongAnBoSungs?.reduce((sum, pa) => {
        if (data.loai === _Enum_Loai_Value.CongKhai) {
          return sum + (pa.soCauTL?.length || 0);
        }
        return sum + (pa.daChon || 0);
      }, 0) || 0;

    return {
      totalVotes,
      totalParticipants: thamGiaBQ.length,
      noResponse: thamGiaBQ.length - totalVotes,
    };
  }, [data, thamGiaBQ]);

  const statusConfig =
    STATUS_CONFIG[data?.trangThai] ||
    STATUS_CONFIG[_Enum_Trang_Thai_Van_De.Moi];
  const mau = data ? Enums_Mau.find((f) => f.value === data.mau) : {};

  return (
    <Modal
      className="result-modal-modern"
      isOpen={isOpen ? true : false}
      size="md"
      centered
    >
      {/* Custom Header */}
      <div className="result-modal-header">
        <button className="header-close-btn" onClick={isClose}>
          <Icon>undo</Icon>
        </button>
        <h5 className="header-title">Kết quả biểu quyết</h5>
        <div className="header-spacer" />
      </div>

      <ModalBody className="result-modal-body">
        <TeamPending loading={isLoading}>
          {data && (
            <>
              {/* Stats Row */}
              <div className="stats-row">
                <div className="stat-card">
                  <div
                    className="stat-icon"
                    style={{ backgroundColor: "#dbeafe", color: "#3b82f6" }}
                  >
                    <Icon>people</Icon>
                  </div>
                  <div className="stat-content">
                    <span className="stat-label">Tổng tham dự</span>
                    <span className="stat-value">
                      {stats.totalParticipants}
                    </span>
                  </div>
                </div>
                <div className="stat-card">
                  <div
                    className="stat-icon"
                    style={{ backgroundColor: "#d1fae5", color: "#10b981" }}
                  >
                    <Icon>how_to_vote</Icon>
                  </div>
                  <div className="stat-content">
                    <span className="stat-label">Đã bình chọn</span>
                    <span className="stat-value">{stats.totalVotes}</span>
                  </div>
                </div>
                <div className="stat-card">
                  <div
                    className="stat-icon"
                    style={{ backgroundColor: "#fee2e2", color: "#ef4444" }}
                  >
                    <Icon>hourglass_top</Icon>
                  </div>
                  <div className="stat-content">
                    <span className="stat-label">Chưa phản hồi</span>
                    <span className="stat-value">{stats.noResponse}</span>
                  </div>
                </div>
              </div>

              {/* Issue Info Card */}
              <div className="result-info-card">
                <div className="info-badge">
                  {mau?.label || "Biểu quyết"} • {_Enums_Loai[data?.loai]} •{" "}
                  {statusConfig.label}
                </div>
                <h4 className="info-title"> {data.name} </h4>

                {/* Attached Files */}
                {data?.fileId && (
                  <div className="info-attachment">
                    <FormAttachFile
                      id={data?.fileId}
                      phienHopId={phienHop?.id}
                      TEndpoint={BoSungVanDesEndpoint}
                      isEdit={true}
                      stylePDF="PDF"
                    />
                  </div>
                )}
              </div>

              {/* Tab Switcher */}
              <div className="tab-switcher">
                <button
                  className={`tab-btn ${activeTab === 0 ? "active" : ""}`}
                  onClick={() => setActiveTab(0)}
                >
                  <Icon>list_alt</Icon>
                  <span>Kết quả</span>
                </button>
                <button
                  className={`tab-btn ${activeTab === 1 ? "active" : ""}`}
                  onClick={() => setActiveTab(1)}
                >
                  <Icon>pie_chart</Icon>
                  <span>Biểu đồ</span>
                </button>
              </div>

              {/* Tab Content */}
              <div className="tab-content">
                {activeTab === 0 && (
                  <div className="results-tab">
                    {/* Main Options */}
                    <div className="results-section">
                      <h6 className="section-title">Phương án chính</h6>
                      <div className="results-list">
                        {data.phuongAnBoSungs
                          ?.filter((cur) => !cur.yKienKhac)
                          .map((item, index) => (
                            <ResultCard
                              key={index}
                              option={item}
                              total={thamGiaBQ.length}
                              isOther={false}
                              canShowVoters={true}
                              loai={data.loai}
                              index={index}
                              prefix="result"
                            />
                          ))}
                      </div>
                    </div>

                    {/* Other Opinions */}
                    {data.phuongAnBoSungs?.filter((cur) => cur.yKienKhac)
                      .length > 0 && (
                      <div className="results-section">
                        <h6 className="section-title">
                          <Icon>add_comment</Icon>Ý kiến khác
                        </h6>
                        <div className="results-list">
                          {data.phuongAnBoSungs
                            ?.filter((cur) => cur.yKienKhac)
                            .map((item, index) => (
                              <ResultCard
                                key={index}
                                option={item}
                                total={thamGiaBQ.length}
                                isOther={true}
                                canShowVoters={true}
                                loai={data.loai}
                                index={index}
                                prefix="resultOther"
                              />
                            ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {activeTab === 1 && (
                  <div className="chart-tab">
                    {dataBieuDo.length > 0 ? (
                      <div className="chart-container">
                        <div className="chart-wrapper">
                          <ResponsiveContainer width="100%" height={280}>
                            <PieChart>
                              <Pie
                                data={dataBieuDo}
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={120}
                                labelLine={false}
                                label={renderCustomizedLabel}
                                dataKey="value"
                              >
                                {dataBieuDo.map((entry, index) => (
                                  <Cell
                                    key={`cell-${index}`}
                                    fill={entry.fill}
                                  />
                                ))}
                              </Pie>
                              <Tooltip
                                formatter={(value, name) => [
                                  `${value} phiếu`,
                                  name,
                                ]}
                              />
                            </PieChart>
                          </ResponsiveContainer>

                          {/* Center Text */}
                          <div className="chart-center-text">
                            <span className="center-value">
                              {stats.totalVotes}
                            </span>
                            <span className="center-label">phiếu</span>
                          </div>
                        </div>

                        {/* Legend */}
                        <div className="chart-legend">
                          {dataBieuDo.map((item, index) => (
                            <LegendItem
                              key={index}
                              item={item}
                              total={stats.totalParticipants}
                            />
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div className="no-data">
                        <img
                          src="/assets/img/data-not-found.png"
                          alt="No data"
                        />
                        <span>Không có dữ liệu biểu đồ</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </TeamPending>

        {/* Action Buttons */}
        <div className="result-action-buttons">
          <Button className="btn-cancel" onClick={isClose}>
            <Icon>cancel</Icon>
            <span>Đóng</span>
          </Button>
          {isOpen &&
            _dataKQBQ?.trangThai === _Enum_Trang_Thai_Van_De.HoatDong &&
            !isDienBien &&
            TOKEN_CLIENT_INFO?.mainRole !== "CV" &&
            noiDung?.trangThai === "DangHop" && (
              <Button className="btn-complete" onClick={hoanThanh}>
                <Icon>check_circle</Icon>
                <span>Hoàn thành</span>
              </Button>
            )}
        </div>
      </ModalBody>
    </Modal>
  );
});

export default ModalKetQua;
